import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'
import uuid from 'react-uuid'
import EndPoints from '../../../services/api'
import axios from '../../../services/axios'
import Loader from '../loader/Loader'
import ClickWrapper from '../click-wrapper/ClickWrapper'
import AuthModal from '../auth/AuthModal'

const SingleContestCard = ({ contestData }) => {
  const [loading, setLoading] = useState(false)

  const {
    contest_association,
    contest_code,
    contest_country,
    contest_email,
    contest_id,
    contest_name,
    contest_owner,
    contest_owner_number,
    end_date,
    initial_coins,
    join_by,
    minimum_participant,
    privacy,
    rewards,
    rules,
    start_date,
    status
  } = contestData

  const history = useHistory()
  const alert = useAlert()
  const { user, loggedIn } = useSelector((state) => state.auth)
  const { addContestUser } = EndPoints.gamePage
  const [showAuthModal, setShowAuthModal] = useState(false)

  const labelRef = useRef()

  const handleJoinContest = () => {
    if (loggedIn) {
      addUserToContest(contest_code)
    } else {
      setShowAuthModal(true)
    }
  }

  const handleClick = (e) => {
    if (labelRef && labelRef.current.contains(e.target)) {
      handleJoinContest()
    } else {
      if (!showAuthModal) history.push(`/single-contest/${contest_name}/${contest_id}`)
    }
  }

  const addUserToContest = async (contest_code) => {
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`
      }
    }
    setLoading(true)
    const enterContestData = {
      user_id: user.user_id,
      name: user.name,
      status: 'Active',
      contest_code
    }
    try {
      //console.log(enterContestData)
      const { data } = await axios.post(
        `${addContestUser}?user_id=${user.user_id}`,
        enterContestData,
        config
      )
      //console.log(data)
      if (data.statusCode === 401) {
        alert.show(JSON.parse(data.body))

        return
      }
      history.push(`/contest/${contest_name}/${contest_id}`)
    } catch (err) {
      console.log(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      onClick={handleClick}
      className="  flex flex-col gap-3 bg-purple-darker rounded-lg relative cursor-pointer overflow-hidden">
      {loading && (
        <div className="absolute inset-0 bg-white bg-opacity-5 grid place-items-center">
          <Loader />
        </div>
      )}
      <div className="bg-blue-500 h-1/4 w-1/4 rounded-full absolute top-0 left-0 transform -translate-x-1/3 -translate-y-1/3 p-4">
        <div className="bg-blue-400 w-full h-full rounded-full"></div>
      </div>

      <div className="bg-yellow-500 h-1/4 w-1/4 rounded-full absolute bottom-0 right-0 transform translate-x-1/3 translate-y-1/2 p-4  ">
        <div className="bg-yellow-300 w-full h-full rounded-full"></div>
      </div>

      <div className="backdrop-filter backdrop-blur-sm p-4 flex flex-col gap-2">
        {' '}
        <h1 className="text-center bg-yellow-600 text-xs px-3 py-1 rounded-sm min-w-max m-auto w-24">
          {status}
        </h1>
        <div className="flex justify-between items-center relative">
          <div className="h-10 w-10 rounded-full grid place-items-center bg-purple-darkest p-1">
            <svg
              width="23"
              height="15"
              viewBox="0 0 23 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.3635 4.75949C20.4453 4.93792 19.5513 5.19609 18.6958 5.52988C17.652 5.95325 16.6663 6.472 15.7562 7.07686C15.1113 6.40707 14.5544 5.68005 14.0953 4.9086C13.3625 3.58533 12.7436 2.21912 12.2433 0.820581C12.1961 0.688512 12.0983 0.573474 11.9652 0.493605C11.8322 0.413737 11.6715 0.373583 11.5084 0.379473C11.3454 0.373583 11.1846 0.413737 11.0516 0.493605C10.9185 0.573474 10.8207 0.688512 10.7735 0.820581C10.2744 2.21947 9.65548 3.58576 8.92155 4.9086C8.46456 5.67917 7.9075 6.40432 7.26066 7.07065C6.34625 6.47275 5.36113 5.95641 4.32103 5.52988C3.48633 5.20052 2.61482 4.94245 1.71946 4.75949C1.58653 4.7325 1.44733 4.73738 1.3175 4.7736C1.18767 4.80982 1.07237 4.87594 0.984554 4.96451C0.89519 5.05604 0.838702 5.16728 0.821771 5.28509C0.804841 5.40289 0.828176 5.52234 0.889016 5.62928C2.28313 8.30912 3.27084 11.1272 3.82864 14.0166C3.85839 14.1624 3.94877 14.2945 4.0835 14.3891C4.21824 14.4836 4.38847 14.5344 4.56355 14.5322H18.5268C18.7019 14.5344 18.8721 14.4836 19.0068 14.3891C19.1416 14.2945 19.2319 14.1624 19.2617 14.0166C19.8195 11.1272 20.8072 8.30912 22.2013 5.62928C22.2621 5.52234 22.2855 5.40289 22.2686 5.28509C22.2516 5.16728 22.1951 5.05604 22.1058 4.96451C22.0173 4.87483 21.9008 4.80803 21.7695 4.77177C21.6382 4.7355 21.4975 4.73125 21.3635 4.75949ZM6.26118 12.4944C6.09954 12.4957 5.94111 12.4563 5.80599 12.3812C5.67088 12.3062 5.56518 12.1989 5.50231 12.073C5.43944 11.9471 5.42224 11.8083 5.45288 11.6741C5.48352 11.5399 5.56062 11.4165 5.67441 11.3194C5.7882 11.2223 5.93353 11.156 6.09197 11.1289C6.2504 11.1018 6.4148 11.1151 6.56429 11.1671C6.71377 11.2191 6.84161 11.3075 6.93158 11.421C7.02154 11.5346 7.06957 11.6681 7.06958 11.8048C7.06959 11.9866 6.98465 12.1611 6.83326 12.2903C6.68186 12.4194 6.47626 12.4928 6.26118 12.4944ZM11.5158 12.4944C11.3137 12.4782 11.1261 12.3988 10.9896 12.2719C10.853 12.1449 10.7774 11.9795 10.7774 11.8079C10.7774 11.6363 10.853 11.4709 10.9896 11.344C11.1261 11.217 11.3137 11.1377 11.5158 11.1214C11.7178 11.1377 11.9054 11.217 12.042 11.344C12.1785 11.4709 12.2542 11.6363 12.2542 11.8079C12.2542 11.9795 12.1785 12.1449 12.042 12.2719C11.9054 12.3988 11.7178 12.4782 11.5158 12.4944ZM16.7777 12.4944C16.6161 12.4957 16.4576 12.4563 16.3225 12.3812C16.1874 12.3062 16.0817 12.1989 16.0188 12.073C15.956 11.9471 15.9387 11.8083 15.9694 11.6741C16 11.5399 16.0771 11.4165 16.1909 11.3194C16.3047 11.2223 16.45 11.156 16.6085 11.1289C16.7669 11.1018 16.9313 11.1151 17.0808 11.1671C17.2303 11.2191 17.3581 11.3075 17.4481 11.421C17.5381 11.5346 17.5861 11.6681 17.5861 11.8048C17.5861 11.9866 17.5012 12.1611 17.3498 12.2903C17.1984 12.4194 16.9928 12.4928 16.7777 12.4944Z"
                fill="#31ACAC"
              />
            </svg>
          </div>

          <h3 className="text-lg text-center w-full absolute left-1/2 transform -translate-x-1/2 ">
            {contest_name}
          </h3>

          <p className="text-xs">{minimum_participant} limit</p>
        </div>
        <div className=" flex justify-between items-start text-center text-white font-500 text-xs ">
          <div className="flex flex-col gap-2">
            <p>Start Date :</p>{' '}
            <p className="text-xs font-600">{start_date !== null ? start_date : '-'}</p>
          </div>
          <div className="flex flex-col gap-2">
            <p>End Date :</p>{' '}
            <p className="text-xs font-600">{end_date != null ? end_date : '-'}</p>{' '}
          </div>
        </div>
        <div className=" my-2 h-20">
          <p className="text-sm font-500">Rules</p>

          <ul className="text-xs list-disc pl-4 text-gray-200 max-h-20 overflow-y-scroll scrollbar-hidden">
            {rules.split('%_$_%').map((rule) => (
              <li className="my-2" key={uuid()}>
                {rule}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex justify-between gap-4 items-center">
          {end_date !== null &&
            Math.floor((new Date(end_date).getTime() - Date.now()) / 86400000) > 0 && (
              <p className="text-xs">
                Ends in {Math.floor((new Date(end_date).getTime() - Date.now()) / 86400000)}
                {Math.floor((new Date(end_date).getTime() - Date.now()) / 86400000) > 1
                  ? `  days`
                  : `  day`}
              </p>
            )}

          <button
            ref={labelRef}
            className={`text-white self-end text-xs z-0 ${`bg-red-500 border-red-500  hover:bg-red-300`}  w-24 p-1 py-2 font-600 rounded-md border-1 transition-all duration-300`}>
            Join Now
          </button>
        </div>
      </div>

      {showAuthModal && (
        <div className="fixed left-0 right-0 top-0 h-screen w-screen z-10 backdrop-filter backdrop-blur-sm grid place-items-center">
          <div className="z-50">
            <ClickWrapper func={() => setShowAuthModal(false)}>
              <AuthModal close={() => setShowAuthModal(false)} />
            </ClickWrapper>
          </div>
        </div>
      )}
    </div>
  )
}

export default SingleContestCard
